import { Component, OnInit } from '@angular/core';
import { DialogService } from '../dialog/dialog.service';
import { DialogRef } from '../dialog/dialog-ref';
import { DialogConfig } from '../dialog/dialog-config';


@Component({
    selector: 'dhs-input-button-popup',
    templateUrl: './input-button-popup.component.html',
    styleUrls: ['./input-button-popup.component.scss'],
    standalone: false
})
export class InputButtonPopupComponent implements OnInit {

    fields: any = [];
    objData: any;
    activatedResource: string;
    configForm: any;
    constructor(public config: DialogConfig,
        public dialog: DialogRef,
        public dialogService: DialogService) { }

    ngOnInit() {
        this.configForm = {
            "submitButton" : true,
            "cancelButton" : true,
            "filterForm" : false,
            "clearOnSave": false,
            "delegateSave": true,
            "cancelRoute": ''
        }
        let receiveddata :any = this.config.data; //this["data"];
        this.fields = receiveddata.formblocks;
        this.activatedResource = receiveddata.activatedResource;
        if (receiveddata.data != null) {
            this.objData = receiveddata.data;
        }
    }

   
    getData(event:any) {
        // console.log("data is =====>>>>>>",event);
        this.dialog.close(event)
    }

}
